import { toastr } from 'react-redux-toastr';
import { ENDPOINTS } from '../constants';
import { apiGetPost } from '../apiHelpers';

export const apiAgreementDecline = (
    AgreementHeaderId,
    notes,
    successTitle,
    successMessage,
    callback,
    onError
) => async dispatch => {
    const type = ENDPOINTS.API.AGREEMENT_DECLINE;
    const data = {
        notes
    };

    dispatch(
        apiGetPost(
            type,
            ['agreement', 'decline', AgreementHeaderId],
            data,
            {},
            undefined,
            true,
            (dispatch, type, response) => {
                onError && onError();
                toastr.error('Error Declining', response.message);
            },
            undefined,
            successTitle,
            successMessage,
            callback
        )
    );
};
